import { ChatbotConversationType, IChatbotConversation } from 'chatbot/types';

import { ConversationMessage } from './ConversationMessage';
import { ConversationParts } from './ConversationParts';
import { ConversationQuestions } from './ConversationQuestions';

interface IProps {
  item: IChatbotConversation;
}

export const ConversationItem = ({ item }: IProps) => {
  if (item.type === ChatbotConversationType.MESSAGE) {
    return <ConversationMessage {...item} />;
  }

  if (item.type === ChatbotConversationType.QUESTIONS) {
    return <ConversationQuestions {...item} />;
  }

  if (item.type === ChatbotConversationType.PARTS_LIST) {
    return <ConversationParts {...item} />;
  }

  return null;
};
